class VariantUpsellSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleCheckbox(true, false);
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleCheckbox(true, true);
    } else {
      this.updateVariantInput();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('select'),
      (select) => select.value,
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  reset() {
    this.dispatchEvent(new Event('change'));
  }

  updateVariantInput() {
    
    const productID = document.querySelector(
      `#product-upsell-${this.dataset.productId}`,
    );

    productID.querySelector(".custom_checkbox-input").setAttribute('data-upsell-variant', this.currentVariant.id);
    productID.querySelector(".custom_checkbox-input").setAttribute('data-club-discount-percent', this.currentVariant.club_discount_percent);
    productID.querySelector(".custom_checkbox-input").setAttribute('data-club-discounted-price', this.currentVariant.club_discounted_price);

    this.toggleCheckbox(
      !this.currentVariant.available,
    );

    var productDiscount = productID.querySelector(".custom_checkbox-input").getAttribute('data-upsell-discount')
    var price = this.currentVariant.price;
    var total = price;

    if (productDiscount) {
      total = price * ( (100-productDiscount) / 100 )
    }

    const itemPrice = productID.querySelector('.price_item.price_item--regular span:not(.u-hide-visually)');
    if (itemPrice !== null && itemPrice !== undefined) {
      itemPrice.innerHTML = "+" + Shopify.formatMoney(total);
    }
    const compareAtPrice = productID.querySelector('.price_item.price_item--sale s');
    if (compareAtPrice !== null && compareAtPrice !== undefined) {
      compareAtPrice.innerHTML = Shopify.formatMoney(price);
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    // if (productForm) productForm.handleErrorMessage();
  }
  

  toggleCheckbox(disable = true, modifyClass = true) {

    const productID = document.querySelector(
      `#product-upsell-${this.dataset.productId}`,
    );

    if (!productID) return;
    const checkbox = productID.querySelector(".custom_checkbox-input");
    const badgeSoldOut = productID.querySelector(".badges .badge--sold-out");
    const badgeDiscount = productID.querySelector(".badges .badge--on-sale");

    if (!checkbox) return;

    if (disable) {
      checkbox.setAttribute('disabled', 'disabled');
      if (badgeDiscount) {
        badgeDiscount.classList.add("u-hide");
      }
      badgeSoldOut.classList.remove("u-hide");
    } else {
      checkbox.removeAttribute('disabled');
      badgeSoldOut.classList.add("u-hide");
      if (badgeDiscount) {
        badgeDiscount.classList.remove("u-hide");
      }
    }

    if (!modifyClass) return;
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-upsell-selects', VariantUpsellSelects);

class VariantUpsellRadios extends VariantUpsellSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-upsell-radios', VariantUpsellRadios);